import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

export const dataAlertSortOptions: OptionsDictionary = {
  'title': {
    id: 'title',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'title.asc',
        field: OrderKeys.title,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.title)]
      },
      'desc': {
        id: 'title.desc',
        field: OrderKeys.title,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.title)]
      }
    }
  },
  'targetName': {
    id: 'targetName',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'targetName.asc',
        field: OrderKeys.targetName,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.targetName)]
      },
      'desc': {
        id: 'targetName.desc',
        field: OrderKeys.targetName,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.targetName)]
      }
    }
  },
  'ownerName': {
    id: 'ownerName',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'ownerName.asc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.ownerName)]
      },
      'desc': {
        id: 'ownerName.desc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.ownerName)]
      }
    }
  },
  'notificationIntervalInMinutes': {
    id: 'notificationIntervalInMinutes',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'notificationIntervalInMinutes.asc',
        field: OrderKeys.notificationIntervalInMinutes,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.notificationIntervalInMinutes)]
      },
      'desc': {
        id: 'notificationIntervalInMinutes.desc',
        field: OrderKeys.notificationIntervalInMinutes,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.notificationIntervalInMinutes)]
      }
    }
  },
  'lastChecked': {
    id: 'lastChecked',
    getMenuItemDisplayValue: () => '',
    subSortOptions: {
      'asc': {
        id: 'lastChecked.asc',
        field: OrderKeys.lastChecked,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.lastChecked)]
      },
      'desc': {
        id: 'lastChecked.desc',
        field: OrderKeys.lastChecked,
        getMenuItemDisplayValue: () => '',
        getButtonDisplayValue: () => '',
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.lastChecked)]
      }
    }
  },
};
